// AI generated

import type { Node, NodeChange } from '@xyflow/react'
import { useCallback, useState } from 'react'
import { getHelperLines } from '../lib/helper-lines'

export function useHelperLines() {
  const [horizontal, setHorizontal] = useState<number | undefined>(undefined)
  const [vertical, setVertical] = useState<number | undefined>(undefined)

  /**
   * Snaps a lone dragged node to its closest neighbour and updates the guides.
   *
   * The snapped coordinates are written into `change.position` **in place**,
   * which is deliberate: React Flow hands us the very object it keeps in its
   * internal drag item, and on mouse-up it re-emits that object verbatim
   * (`XYDrag`'s `end` -> `updateNodePositions(dragItems, false)`) instead of
   * recomputing it. Returning a copy would let the final, un-snapped pointer
   * position overwrite the snap and get persisted.
   */
  const snapToHelperLines = useCallback(
    (changes: NodeChange<Node>[], nodes: Node[]): NodeChange<Node>[] => {
      const change = changes[0]

      if (
        changes.length !== 1 ||
        change?.type !== 'position' ||
        !change.dragging ||
        !change.position
      ) {
        setHorizontal(undefined)
        setVertical(undefined)
        return changes
      }

      const helperLines = getHelperLines(change, nodes)

      setHorizontal(helperLines.horizontal)
      setVertical(helperLines.vertical)

      change.position.x = helperLines.snapPosition.x ?? change.position.x
      change.position.y = helperLines.snapPosition.y ?? change.position.y

      return changes
    },
    [],
  )

  return { horizontal, vertical, snapToHelperLines }
}
